import {lazy} from 'react'
import * as B from '../block'
import {meta} from './meta'

const Admin = lazy(() => import('./admin').then(m => ({default: m.Admin})))

const InnerBlock = lazy(() =>
  import('./SearchWithinBlock').then(m => ({default: m.SearchWithinBlock})),
)

export const searchWithinBlockInfo = B.blockInfo({
  ...meta,
  Admin,
  InnerBlock,
})
